import { FC } from 'react';
import ChevronDownIcon from '../../../../public/images/png/chevron-down.png';
import ChevronUpDownIcon from '../../../../public/images/png/chevron-up-down.png';
import ChevronUpIcon from '../../../../public/images/png/chevron-up.png';
import { TableHeaderProps } from './interfaces/Table';
import TableCell from './TableCell';
const visualizeElementsAndSpacing = false;
const borderClassToVisualizeElementsAndSpacing = visualizeElementsAndSpacing
  ? 'border-white border'
  : '';
const tableHeaderSpacingClasses = {
  tableHeaderPadding: 'p-0',
  tableHeaderGap: 'gap-sm-wholestep-dec',
};
const convertToFrUnits = (percentages: number[]) => {
  const totalPercentage = percentages.reduce((acc, curr) => acc + curr, 0);
  return percentages
    .map((percentage) => `${(percentage / totalPercentage).toFixed(2)}fr`)
    .join(' ');
};
const TableHeader: FC<
  TableHeaderProps & { rightAlignLastColumn?: boolean }
> = ({
  columnHeaders,
  columnWidths,
  sortable,
  onSort,
  sortedColumn,
  isAscending,
  rightAlignLastColumn = true,
}) => {
  const getSortIconPng = (index: number): string => {
    if (sortable && !sortable[index]) return '';
    if (sortedColumn === index) {
      return isAscending ? ChevronUpIcon.src : ChevronDownIcon.src;
    }
    return ChevronUpDownIcon.src;
  };

  const getHeaderValue = (
    header: string | { value: string; align?: 'left' | 'center' | 'right' },
  ) => (typeof header === 'string' ? header : header.value);

  const getHeaderAlignment = (
    header: string | { value: string; align?: 'left' | 'center' | 'right' },
    index: number,
  ): 'left' | 'center' | 'right' => {
    if (columnHeaders.length === 1) {
      return 'left';
    }
    if (index === columnHeaders.length - 1) {
      return rightAlignLastColumn ? 'right' : 'left';
    }
    if (typeof header === 'string' || !header.align) return 'left';
    return header.align;
  };

  return (
    <div
      className={`grid w-full 
        ${tableHeaderSpacingClasses.tableHeaderPadding} 
        ${tableHeaderSpacingClasses.tableHeaderGap} 
        ${borderClassToVisualizeElementsAndSpacing}`}
      style={{
        gridTemplateColumns: columnWidths
          ? convertToFrUnits(columnWidths)
          : '1fr',
      }}
    >
      {columnHeaders.map((header, index) => {
        const align = getHeaderAlignment(header, index);
        const alignmentClass =
          align === 'right'
            ? 'text-right items-end'
            : align === 'center'
            ? 'text-center items-center'
            : 'text-left items-start';
        return (
          <div
            key={index}
            className={`flex flex-col justify-start ${alignmentClass} ${
              sortable && sortable[index] ? 'cursor-pointer' : ''
            } ${borderClassToVisualizeElementsAndSpacing}`}
            onClick={() =>
              sortable && sortable[index] && onSort && onSort(index)
            }
          >
            <TableCell
              mainText={getHeaderValue(header)}
              mainTextSize="sm"
              mainTextColor="secondary"
              rightIconUrl={getSortIconPng(index)}
              align={align}
            />
          </div>
        );
      })}
    </div>
  );
};
export default TableHeader;
